module.exports = (__webpack_require__(3))(936);